import { PRODUCTS } from '../config/columns.config';

const sumProducts = (obj = {}) =>
  PRODUCTS.reduce((s, p) => s + (obj[p.key] || 0), 0);

export const buildSummaryRows = (totals, config) => {
  const retailTotal = sumProducts(totals.retail);
  const projectTotal = sumProducts(totals.project);
  const retailBudget = totals.retailBudget || 0;
  const projectBudget = totals.projectBudget || 0;

  const grandTotal = retailTotal + projectTotal;
  const grandBudget = retailBudget + projectBudget;

  const grandTotalValues = {};
  PRODUCTS.forEach(p => {
    grandTotalValues[p.key] = (totals.retail?.[p.key] || 0) + (totals.project?.[p.key] || 0);
  });

  const calculateProRata = (total, budget) => {
    if (!budget || !config?.dateRange?.start || !config?.dateRange?.end) {
      return 0;
    }

    const startDate = new Date(config.dateRange.start);
    const endDate = new Date(config.dateRange.end);
    const today = new Date();

    const totalDuration = endDate - startDate;
    if (totalDuration <= 0) return 0;

    let timeElapsed = 0;
    if (today < startDate) {
      timeElapsed = 0;
    } else if (today > endDate) {
      timeElapsed = totalDuration;
    } else {
      timeElapsed = today - startDate;
    }

    const totalDays = Math.ceil(totalDuration / (1000 * 60 * 60 * 24)) + 1;
    const daysPassed = Math.ceil(timeElapsed / (1000 * 60 * 60 * 24)) + 1;

    const proRataBudget = (budget / totalDays) * daysPassed;

    return proRataBudget > 0 ? (total / proRataBudget) * 100 : 0;
  };

  return [
    {
      id: 'Retail',
      label: 'Retail',
      values: totals.retail || {},
      total: retailTotal,
      budget: retailBudget,
      percentageAchieved: retailBudget ? (retailTotal / retailBudget) * 100 : 0,
      proRataAchieved: calculateProRata(retailTotal, retailBudget),
    },
    {
      id: 'Project',
      label: 'Project',
      values: totals.project || {},
      total: projectTotal,
      budget: projectBudget,
      percentageAchieved: projectBudget ? (projectTotal / projectBudget) * 100 : 0,
      proRataAchieved: calculateProRata(projectTotal, projectBudget),
    },
    {
      id: 'Total',
      label: 'Grand Total',
      values: grandTotalValues,
      total: grandTotal,
      budget: grandBudget,
      percentageAchieved: grandBudget ? (grandTotal / grandBudget) * 100 : 0,
      proRataAchieved: calculateProRata(grandTotal, grandBudget),
    },
  ];
};